import React, { useEffect } from 'react'
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom'
import Login from '../Components/Login'
import Home from '../pages/Home'
import ContactUs from '../pages/ContactUs'
import FoodMenu from '../pages/FoodMenu'
import Favorite from '../pages/Favorite'
import Cart from '../pages/Cart'
import CheckOut from '../pages/CheckOut'
import AboutUs from '../pages/AboutUs'
import Team from '../pages/Team'
import Layout from '../Components/Layout/Layout'
import Home2 from '../pages/Home2'
import Home3 from '../pages/Home3'
import Home4 from '../pages/Home4'
import NotFound from '../pages/NotFound'
import ServerError from '../pages/ServerError'
import UnderMaintenance from '../pages/UnderMaintence'

const RoutePaths = () => {
  
    // scroll to top
    const ScrollToTop = () => {
        const { pathname } = useLocation();
        useEffect(() => {
            window.scrollTo(0, 0);
        }, [pathname]);
        return null;
    };
    return (
        <Router>
            <ScrollToTop />
            {/* <HoverEffect /> */}
            <Routes>
                {/* Login Route */}
                <Route path="/" element={<Login />} />

                {/* Layout with nested routes */}
                <Route path="/" element={<Layout />}>
                    <Route path="home" element={<Home />} />
                    <Route path="contact" element={<ContactUs />} />
                    <Route path="food_menu" element={<FoodMenu />} />
                    <Route path="favorite" element={<Favorite />} />
                    <Route path="cart" element={<Cart />} />
                    <Route path="checkout" element={<CheckOut />} />
                    <Route path="about_us" element={<AboutUs />} />
                    <Route path="chefs" element={<Team />} />
                    <Route path="home2" element={<Home2 />} />
                    <Route path="home3" element={<Home3 />} />
                    <Route path="home4" element={<Home4 />} />
                </Route>
                <Route path="*" element={<NotFound />} />
                <Route path="notfound" element={<NotFound />} />
                <Route path="servererror" element={<ServerError />} />
                <Route path="undermaintenance" element={<UnderMaintenance />} />
            </Routes>
        </Router>

    )
}

export default RoutePaths
